import { render, staticRenderFns } from "./SendMessageGroupList.vue?vue&type=template&id=78964348&scoped=true&lang=pug"
import script from "./SendMessageGroupList.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupList.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageGroupList.vue?vue&type=style&index=0&id=78964348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78964348",
  null
  
)

export default component.exports